"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForListFragmentDoc = exports.LoginFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
const Region_generated_1 = require("./Region.generated");
exports.LoginFullFragmentDoc = client_1.gql `
    fragment LoginFull on Login {
  Id
  SessionId
  LastActivity
  LastPlatform
  Phone
  FirebaseId
  EcoPoints
  Role
  UserName
  Email
  PolicyAccepted
  HomeRegion {
    ...RegionFull
  }
}
    ${Region_generated_1.RegionFullFragmentDoc}`;
exports.LoginForListFragmentDoc = client_1.gql `
    fragment LoginForList on Login {
  Id
  LastPlatform
  Phone
  EcoPoints
  Role
  UserName
  Email
  PolicyAccepted
  HomeRegion {
    ...RegionFull
  }
}
    ${Region_generated_1.RegionFullFragmentDoc}`;
//# sourceMappingURL=Login.generated.js.map